module.exports = __webpack_public_path__ + "static/img/partner16.8bd7c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner16.png
// module id = Bu0l
// module chunks = 0